const options = {"customVariables":["@hds/help-common/src/assets/variables.scss"],"treeShake":true,"defaultAssets":false,"theme":{"dark":false,"themes":{"light":{"primary":"#ff5340","accent":"#ff5340","info":"#3abbd5","success":"#65ad25","black":"#111"}}},"icons":{"iconfont":"mdi"}}

import plugin from '@ustra/nuxt-vuetify/src/plugins/nuxt-vuetify-plugin'

// import Middleware from '../middleware'

export default plugin
